// Customer Mapper feature disabled for now — only consumer of this import
// import { routes } from 'data/routes';

import { IconName } from 'components/Icons';

export type ItemList = {
  id: number;
  name: string;
  to: string;
  // Exact-match only (react-router NavLink's `end`) — needed on a root item
  // whose `to` is a literal prefix of a sibling's (e.g. "Customers"
  // "/customers" vs "Deleted customers" "/customers/deleted"), otherwise
  // both light up ".active" at once while on the sibling's page.
  end?: boolean;
};

export type Resource = {
  id: number;
  name: string;
  to?: string;
  icon?: IconName;
  list?: ItemList[];
};

const resources: Resource[] = [
  // Customer Mapper feature disabled for now — keep the entry commented so it can be
  // restored as-is when the feature comes back.
  // {
  //   id: 1,
  //   name: 'Customers',
  //   list: [
  //     {
  //       id: 1,
  //       name: 'Active customers',
  //       to: routes.customers,
  //       end: true,
  //     },
  //     {
  //       id: 2,
  //       name: 'Deleted customers',
  //       to: routes.deletedCustomers,
  //     },
  //   ],
  // },
  {
    id: 2,
    name: 'Catalogue',
    list: [
      //   {
      //     id: 1,
      //     name: 'Seasons and zones',
      //     to: '/catalogue/seasons-and-zones',
      //   },
      {
        id: 2,
        name: 'Budget',
        to: '/catalogue/budget',
      },
      {
        id: 3,
        name: 'Orders',
        to: '/catalogue/orders',
      },
      {
        id: 4,
        name: 'Size scales',
        to: '/catalogue/size-scales',
      },
    ],
  },
  {
    id: 3,
    name: 'Notifications',
    list: [
      {
        id: 1,
        name: 'Notifications/Categories',
        to: '/catalogue/notifications-categories',
      },
      {
        id: 2,
        name: 'Notifications',
        to: '/catalogue/notifications',
      },
    ],
  },
  {
    id: 4,
    name: 'Users',
    list: [
      {
        id: 1,
        name: 'Active users',
        to: '/users/',
      },
      {
        id: 2,
        name: 'Deleted users',
        to: '/users/deleted',
      },
    ],
  },
];

export { resources };
